import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import * as FIELDS from '../../fields';
import { SALES_GROUP_REPORT_ID } from './salesGroupReportId';

const emptyColumns = [FIELDS.SALES_GROUP].map(createFooterMapper(SALES_GROUP_REPORT_ID));

const reportFooterColumnDefinition = [...emptyColumns];

export default reportFooterColumnDefinition;
